import { HttpErrorResponse } from '@angular/common/http';
import { UIErrorStatus } from '@common/enums/ui-error-status.enum';

export function hasErrorResponseText(res: unknown): boolean {
  if (!(res instanceof HttpErrorResponse)) return false;

  const { status, error } = res || {};

  if (error?.uiErrorStatus === UIErrorStatus.Displayed) return false;

  const isServerError = status === 500 || status === 512;
  const hasErrorDetails = !!error && Object.keys(error).length > 0;

  if (isServerError && !hasErrorDetails) return false;

  return true;
}
